// extracted by mini-css-extract-plugin
module.exports = {"header":"login_header__3fc0I","authContainer":"login_authContainer__3pJIR","footer":"login_footer__Rdf7t","btn":"login_btn__3NpNh","alert":"login_alert__3s3B8"};